import { createSignal } from 'solid-js'

const [typeProofreadingList, setTypeProofreadingList] = createSignal<HTMLDivElement>()

export {
  typeProofreadingList,
  setTypeProofreadingList
}